import { render } from "./AddCodecsiView.vue?vue&type=template&id=f1f183a2"
import script from "./AddCodecsiView.vue?vue&type=script&lang=js"
export * from "./AddCodecsiView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__